
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HelperService } from '@core/Services';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    // private auth: AuthService,
    private helper: HelperService
    ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    if(request.url.includes('auth/invitation') || request.url.includes('gecko.kelolain.id') || request.url.includes('/operationalTime') || request.url.includes('/saved') || request.url.includes('/deleted') || request.url.includes('/click') || request.url.includes('check?customer_number=') || request.url.includes('logs') ){
      return next.handle(request);
    }else{
      return next.handle(request).pipe(
        catchError((err) => {

          switch (err.status) {
            // case 401:
            //   setTimeout(()=>{
            //     this.helper.errorAlertHandler(err);
            //     this.helper.dismissLoading();
            //   },1000)
            //   break;

            // case 400:
            //   setTimeout(()=>{
            //     this.helper.errorAlertHandler(err);
            //     this.helper.dismissLoading();
            //   },1000)

            // break;
            // case 302:
            //   //JWT Expired
            //   setTimeout(()=>{
            //     // this.uServ.setLoading(false);
            //     // this.uServ.openSnackBar('Internal Server Forbiden');
            //   },3000)
            // break;


            default:

              setTimeout(()=>{
                this.helper.errorAlertHandler(err);
                this.helper.dismissLoading();
              },1000)
              break;
          }


          const error = err.error.message || err.statusText;
          return throwError(error);
        })
      );
    }

  }
}


